<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center mr-4">
        <h2>Enzyme Analyzer</h2>
      </div>
      <v-btn
        to="/ec"
        text
      >
        <span>EC Number Prediction</span>
      </v-btn>
      <v-btn
        to="/vv"
        text
      >
        <span>Enzyme Selection</span>
      </v-btn>
      <v-btn
        to="/activity"
        text
      >
      <span>Activity prediction</span>
      </v-btn>
      <v-btn
        to="/result"
        text
      >
        <span>Result inquiry</span>
      </v-btn>
      <v-btn
        to="/help"
        text
      >
        <span>Help</span>
      </v-btn>
      <v-spacer></v-spacer>
      <span class="mr-4">
        Login User : {{ this.$store.state.userName }}
      </span>
      <v-btn @click="logout">
        <span>Logout</span>
      </v-btn>
    </v-app-bar>
    <v-main>
      <router-view/>
      <!-- 処理中のプログレスバー -->
      <v-dialog v-model="$store.state.util.processing" hide-overlay persistent width="350">
        <v-card color="primary" dark>
          <v-card-text>
            Processing...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- メッセージ用のスナックバー -->
      <v-snackbar v-model="$store.state.util.snackbar" :centered="true" :color="$store.state.util.color" :timeout="-1">
        {{ $store.state.util.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="closeSnackbar">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <!-- 確認ダイアログ -->
      <v-dialog v-model="$store.state.util.confirm" persistent width="350">
        <v-card color="yellow">
          <v-card-title>
            Confirmed
          </v-card-title>
          <v-card-text>
            {{ $store.state.util.confirmText }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="grey lighten-2"
              @click="$store.state.util.afterConfirm"
            >
              Yes
            </v-btn>
            <v-btn
              depressed
              color="grey lighten-2"
              @click="hideConfirm"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-main>
  </v-app>
</template>

<script>
import router from "./router";
import { mapActions } from "vuex";

export default {
  name: 'App',
  data: () => ({
    //
  }),
  mounted: function() {
    this.getUserName();
  },
  methods: {
    ...mapActions("util", ["showProgress", "hideProgress", "openSnackbar", "closeSnackbar", "showConfirm", "hideConfirm",]),
    logout: function() {
      this.$session.destroy();
      this.$store.dispatch('updateUserName', null);
      router.push("/login");
    },
    getUserName: function() {
      this.$session.start();
      if (this.$session.has("userName")) {
        this.$store.dispatch('updateUserName', this.$session.get('userName'));
      }
    },
  }
};
</script>
<style>
  .v-btn {
    text-transform: none;
  }
</style>